const CONFIRM_HSA_ACCOUNT_COMPLETE_STORAGE_KEY = 'spence:payout-setup:confirm-hsa-complete';

function getConfirmHsaAccountStorageKey(): string {
  if (typeof window === 'undefined') {
    return CONFIRM_HSA_ACCOUNT_COMPLETE_STORAGE_KEY;
  }

  const euId = window.localStorage?.getItem('euId')?.trim();
  return euId
    ? `${CONFIRM_HSA_ACCOUNT_COMPLETE_STORAGE_KEY}:${euId}`
    : CONFIRM_HSA_ACCOUNT_COMPLETE_STORAGE_KEY;
}

export function isConfirmHsaAccountFrontendComplete(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    const value = window.localStorage?.getItem(getConfirmHsaAccountStorageKey());
    return value != null && value.trim().length > 0;
  } catch {
    return false;
  }
}

/** ISO timestamp stored when HSA confirm completed; null for legacy `'1'` flag. */
export function readConfirmHsaAccountVerifiedAtIso(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const value = window.localStorage?.getItem(getConfirmHsaAccountStorageKey())?.trim();
    if (!value || value === '1') {
      return null;
    }

    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : value;
  } catch {
    return null;
  }
}

export function markConfirmHsaAccountFrontendComplete(): void {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage?.setItem(getConfirmHsaAccountStorageKey(), new Date().toISOString());
  } catch {
    // Ignore quota / privacy mode.
  }
}

export function clearConfirmHsaAccountFrontendComplete(): void {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    const keysToRemove: string[] = [];
    for (let index = 0; index < window.localStorage.length; index += 1) {
      const key = window.localStorage.key(index);
      if (key?.startsWith(CONFIRM_HSA_ACCOUNT_COMPLETE_STORAGE_KEY)) {
        keysToRemove.push(key);
      }
    }

    keysToRemove.forEach(key => {
      window.localStorage?.removeItem(key);
    });
    // Do not clear HSA verifying storage here — logout must keep it so re-login
    // can still show Verifying. Call clearHsaAccountVerifyingDetails() separately
    // when a full reset is required.
  } catch {
    // Ignore quota / privacy mode.
  }
}
